"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function HeroSection() {
  const { t } = useLanguage();

  return (
    <section className="bg-[#fefce8] py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="w-full lg:w-[60%]">
            <span className="inline-block bg-primary text-white text-xs font-bold px-4 py-1.5 rounded-full mb-4">
              {t("areas.eyebrow")}
            </span>
            <h1 className="text-3xl md:text-[42px] font-black text-secondary leading-tight mb-4">
              {t("areas.h1")}
            </h1>
            <p className="text-lg text-[#374151] leading-relaxed mb-3 max-w-2xl">
              {t("areas.subhead")}
            </p>
            <p className="text-base text-gray-600 leading-relaxed mb-8 max-w-2xl">
              {t("areas.intro")}
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div>
                <div className="text-3xl md:text-4xl font-black text-primary mb-1">12</div>
                <div className="text-sm text-[#374151] font-medium">{t("serviceAreas.heroStat1Label")}</div>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-black text-primary mb-1">47</div>
                <div className="text-sm text-[#374151] font-medium">{t("serviceAreas.heroStat2Label")}</div>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-black text-primary mb-1">{t("serviceAreas.heroStat3Label")}</div>
                <div className="text-sm text-[#374151] font-medium">{t("serviceAreas.heroStat3Sub")}</div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[40%]">
            <div className="relative rounded-xl overflow-hidden border-2 border-primary bg-[#064e3b]">
              <img
                src="https://placehold.co/480x360/064e3b/fefce8?text=MIAMI-DADE+COVERAGE+MAP"
                alt={t("serviceAreas.heroImageAlt")}
                className="w-full h-auto object-cover relative z-10"
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = "none";
                }}
              />
              <div className="absolute top-[20%] left-[30%] w-3 h-3 rounded-full bg-[#fbbf24] border-2 border-white shadow-sm z-20" />
              <div className="absolute top-[35%] left-[55%] w-3 h-3 rounded-full bg-[#fbbf24] border-2 border-white shadow-sm z-20" />
              <div className="absolute top-[15%] left-[70%] w-3 h-3 rounded-full bg-[#fbbf24] border-2 border-white shadow-sm z-20" />
              <div className="absolute top-[50%] left-[25%] w-3 h-3 rounded-full bg-[#fbbf24] border-2 border-white shadow-sm z-20" />
              <div className="absolute top-[60%] left-[60%] w-3 h-3 rounded-full bg-[#fbbf24] border-2 border-white shadow-sm z-20" />
              <div className="absolute top-[45%] left-[80%] w-3 h-3 rounded-full bg-[#fbbf24] border-2 border-white shadow-sm z-20" />
              <div className="absolute top-[70%] left-[45%] w-3 h-3 rounded-full bg-[#fbbf24] border-2 border-white shadow-sm z-20" />
              <div className="absolute top-[25%] left-[45%] w-3 h-3 rounded-full bg-[#fbbf24] border-2 border-white shadow-sm z-20" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}